import Vue from "vue";
import VueRouter from "vue-router";
import NotFound from "../views/errors/404.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Somosoftware",
    meta: {
      title: "Somosoftware",
    },
    component: () =>
      import("../views/Home.vue"),
  },
  {
    path: "*",
    name: NotFound,
    meta: {
      title: "404",
    },
    component: () => import("../views/errors/404.vue"),
  },
];
const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
});

export default router;
